import { ContainerQueries, LayoutBreakpoints, LayoutSize } from './types';

function matchesBreakpoint(
  width: number,
  breakpoint: ContainerQueries
): boolean {
  const meetsMin =
    breakpoint.minWidth === undefined || width >= breakpoint.minWidth;
  const meetsMax =
    breakpoint.maxWidth === undefined || width <= breakpoint.maxWidth;
  return meetsMin && meetsMax;
}

export function getSize(
  breakpoints: LayoutBreakpoints,
  width: number
): LayoutSize {
  switch (true) {
    case matchesBreakpoint(width, breakpoints.medium):
      return 'medium';
    case matchesBreakpoint(width, breakpoints.large):
      return 'large';
    case matchesBreakpoint(width, breakpoints.xlarge):
    default:
      return 'xlarge';
  }
}
